import { httpService } from "@/common/services/HttpService";
import { BackofficeUser } from "@/common/models/BackofficeUser";
import { UAUserAccess } from "@/user-administration/models/UAUserAccess";
import { Access } from "@/common/models/Access";
import { AccessLevel } from "@/common/enums/AccessLevel";
import { UserRole } from "@/common/enums/UserRole";

class UserService {
  currentUser: BackofficeUser | undefined;

  isManager(storeId: string): boolean {
    return (
      this.isAdmin(storeId) ||
      this.currentUser?.access?.find((access) => access.resourceId === storeId)?.accessLevel === AccessLevel.MANAGER
    );
  }

  isAdmin(storeId: string | null = null): boolean {
    return (
      this.currentUser?.roles.find((value) => value === UserRole.ADMIN) !== undefined ||
      this.currentUser?.access?.find((access) => access.resourceId === storeId)?.accessLevel === AccessLevel.ADMIN
    );
  }

  hasManagerRights(): boolean {
    return (
      this.currentUser?.roles.find((value) => value === UserRole.ADMIN) !== undefined ||
      this.currentUser?.access?.some(
        (access: Access) => access.accessLevel === AccessLevel.ADMIN || access.accessLevel === AccessLevel.MANAGER
      ) === true
    );
  }

  canDelete(userAccess: UAUserAccess): boolean {
    return (
      this.isAdmin(userAccess.resourceId) ||
      (this.isManager(userAccess.resourceId) && userAccess.accessLevel === "STAFF")
    );
  }

  async getMe(): Promise<BackofficeUser> {
    const { data } = await httpService.getInstance().get<BackofficeUser>("/api/v1/user");
    return data;
  }

  async collectUser(): Promise<void> {
    this.currentUser = await this.getMe();
  }
}

export const userService = new UserService();
